import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import {
  catchError,
  concatMap,
  delay,
  retry,
  repeatWhen,
  takeWhile,
} from 'rxjs/operators';

import { BootstrapError } from '../../models';
import { StatusCommandParams } from './status-params';
import { BaseCommand } from '../Command';

@Injectable()
export class StatusCommandService extends BaseCommand<StatusCommandParams> {
  private readonly bootstrapAccountErrorMessage =
    'Could not bootstrap account. Inviting users to the account will be disabled until bootstrap is complete';

  constructor(
    private readonly httpClient: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {
    super();
  }

  public execute(params: StatusCommandParams): void | Observable<unknown> {
    const { accountId } = params;
    let repeating = false;
    return this.httpClient
      .get<{ state: string; id: string }>(
        `${this.apiBaseUrl}accounts/${accountId}`,
      )
      .pipe(
        concatMap(({ state, id }) => {
          repeating = state !== 'PENDING';
          return repeating ? of({ state, id }) : EMPTY;
        }),
        repeatWhen((status) =>
          status.pipe(
            takeWhile(() => !repeating),
            delay(1000),
          ),
        ),
        retry(2),
        catchError((err) =>
          throwError(
            new BootstrapError({
              error: err,
              messageHeader: this.bootstrapAccountErrorMessage,
            }),
          ),
        ),
      );
  }
}
